module.exports = __webpack_public_path__ + "static/media/Ancient Warrior.efa4656f.jpg";